import { render } from "./AddUrlForm.vue?vue&type=template&id=237ecf02&scoped=true"
import script from "./AddUrlForm.vue?vue&type=script&lang=js"
export * from "./AddUrlForm.vue?vue&type=script&lang=js"

import "./AddUrlForm.vue?vue&type=style&index=0&id=237ecf02&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-237ecf02"]])

export default __exports__